// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"LapuWiseCurrencyPage_inputContainer__LaZt-"};